import React, {createContext, useEffect} from 'react';
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector, tokenState} from "../../state/auth";
import jwt_decode from "jwt-decode";

const AuthContext = createContext({
  token: "",
  data: () => {
  },
  isLoggedIn: false,
  onLogin: (token, refreshToken) => {
    console.warn("not implemented. token: ", token, "; refreshToken: ", refreshToken)
  },
  onLogout: () => {
  },
});

export const AuthContextProvider = (props) => {
  const setTokenState = useSetRecoilState(tokenSelector)
  const token = useRecoilValue(tokenState)

  useEffect(() => {
    const storedTokenData = localStorage.getItem('freddosrl_guardian__token');
    if (storedTokenData == null) {
      logoutHandler()
      return
    }
    try {
      const parsed = JSON.parse(storedTokenData)
      if (parsed.accessToken && parsed.accessToken.length > 0) {
        setTokenState(parsed)
      }
    } catch (err) {
      logoutHandler()
    }
  }, [setTokenState]);

  const logoutHandler = () => {
    localStorage.removeItem('freddosrl_guardian__token');
    setTokenState(null);
  };

  const loginHandler = (token, refreshToken) => {
    setTokenState({
      accessToken: token,
      refreshToken: refreshToken
    })
  };

  return (
    <AuthContext.Provider
      value={{
        token: token,
        data: () => {
          const decoded = jwt_decode(token.accessToken);
          return {
            "username": decoded.username,
            "role": decoded.role,
          }
        },
        isLoggedIn: token != null && token.accessToken.length > 0,
        onLogout: logoutHandler,
        onLogin: loginHandler,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;